import { FunctionComponent } from "react";
import HenryAvatorImg from "./HenryAvator.png";

interface HenryAvatorProps {
  height?: number;
  width?: number;
}

const HenryAvator: FunctionComponent<HenryAvatorProps> = ({ height = 169, width = 177 }: HenryAvatorProps) => {
  return <img src={HenryAvatorImg} alt="henry" height={height} width={width} />;
};
export default HenryAvator;
